import APIService from '@/services/APIService.js';

export default {

  getLiquidacoes(includeExpiredRecords) {
    return APIService.apiCall().get(`/liquidacaoCji3/getLiquidacoes/${includeExpiredRecords}`);
  },

  salvarLiquidacaoCji3(postData) {
    return APIService.apiCall().post(`/liquidacaoCji3/salvar`, JSON.stringify(postData));
  },

  excluirLiquidacaoCji3(id) {
    return APIService.apiCall().get(`/liquidacaoCji3/excluir/${id}`);
  },

  executarLiquidacaoCji3(id) {
    return APIService.apiCall().get(`/liquidacaoCji3/executar/${id}`);
  },

  download(id, config = {}) {
    return APIService.apiCall().get(`/liquidacaoCji3/baixarPlanilha/${id}`, { responseType: 'blob', ...config });
  }
};


